import React, { useState } from "react";
import {
  Button,
  Typography,
  Box,
  Avatar,
  IconButton,
  Paper,
} from "@mui/material";
import { uploadSchoolLogo } from "../../../ApiService/ApiService";
import { Create, UploadFileOutlined } from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function UploadImage({ fetchSchoolLogo, schoolLogo }) {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const schoolId = sessionStorage.getItem("schoolId");
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  console.log("SCHOOL LOGO", schoolLogo);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async () => {
    try {
      if (file && file.size > 300 * 1024) {
        setDialog({
          visible: true,
          title: "Error",
          message: "File size must be less than 300KB.",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      console.log("FORM DATA", formData);
      const response = await uploadSchoolLogo(formData);
      // console.log("Upload successful:", response.data);
      setDialog({
        visible: true,
        title: "Success",
        message: "Image uploaded",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      fetchSchoolLogo(schoolId);
      setFile(null);
      setPreview(null);
    } catch (error) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Something went wrong",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: { xs: 3, md: 10 },
          width: { xs: "90%", sm: "70%", md: "50%" },
          padding: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "600", marginBottom: 2 }}
        >
          Upload School Logo
        </Typography>

        <Box sx={{ position: "relative", display: "inline-block" }}>
          <Avatar
            src={preview ? preview : schoolLogo}
            alt="Profile"
            sx={{
              height: { xs: 120, sm: 160, md: 240 },
              width: { xs: 120, sm: 160, md: 240 },
              border: "1px solid gray",
              borderRadius: "50%",
              marginBottom: 1,
            }}
          />

          <IconButton
            onClick={() => {
              const fileInput = document.getElementById(
                "contained-button-file"
              );
              fileInput.click();
            }}
            sx={{
              position: "absolute",
              bottom: -10,
              left: "50%",
              transform: "translateX(-50%)",
              color: "white",
              backgroundColor: "#2659c8",
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: "white",
                border: "1px solid #2659c8",
                color: "#2659c8",
              },
            }}
          >
            <Create />
          </IconButton>
        </Box>
        <input
          accept="image/*"
          style={{ display: "none" }}
          id="contained-button-file"
          type="file"
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleSubmit}
          disabled={!file}
          sx={{
            textTransform: "unset",
            marginTop: 2,
            height: 40,
            width: { xs: 150, sm: 180, md: 200 },
          }}
        >
          Upload <UploadFileOutlined sx={{ marginLeft: 1 }} />
        </Button>
        <Typography
          variant="caption"
          color="error"
          sx={{ fontSize: 12, marginTop: 1, textAlign: "center" }}
        >
          Note: File size should be less than 300KB
        </Typography>
      </Paper>
    </>
  );
}

export default UploadImage;
